import MainPage from './main';
import Edit from './edit';
import Single from './singlePage';

const routes = [
    {
        path: '/*',
        Component: MainPage,
        props: {},
    },
    {
        path: '/:id/edit',
        Component: Edit,
        props: {},
    },
    {
        path: '/:id',
        Component: Single,
        props: {},
    },
    {
        path: '/new',
        Component: Edit,
        props: {
            isNew: true,
        },
    },
];

export default routes;
